// LAS PERSONAS DE LA CASA, CON SU PARENTESCO Y SU CLAVE DE SIEMPRE.
//
// Nace con los medicos por persona (punto 10, fase 1): "de quien es este
// medico" necesita la lista de la casa con un nombre que se pueda leer al lado
// de una clave que se pueda guardar.
//
// ── NO SE VUELVE A DERIVAR LA LISTA ─────────────────────────────────────────
//
// Las claves ("primary", "spouse", el id del dependiente o "dep"+posicion) ya
// las calcula `enumerateInsuredMembers` en policyTypes.js, que es lo que usan
// `policyInsured` y `memberIdsByPerson`. Esto lo LLAMA, no lo copia: hay ya dos
// copias inline de esa cuenta en PoliciesView.jsx y una cuarta acabaria en que
// el mismo hijo tiene dos claves distintas segun la pantalla, y entonces su
// medico desaparece al abrir otra pestaña.
//
// Lo unico que se añade es el PARENTESCO para poder escribirlo: eso
// `enumerateInsuredMembers` no lo devuelve porque a las polizas no les hace
// falta.
//
// Ojo con lo que la lista NO trae: un dependiente con `separateProfile` queda
// fuera —tiene su propia ficha, y ahi van sus medicos— igual que queda fuera de
// los asegurados.

import { enumerateInsuredMembers } from './policyTypes.js';

/**
 * @param {object} client ficha en el formato del SPA
 * @param {'es'|'en'} lang para el parentesco
 * @returns {Array<{key:string, nombre:string, parentesco:string, member:object}>}
 */
export function personasDelHogar(client, lang = 'es') {
  if (!client) return [];
  const es = lang !== 'en';
  return enumerateInsuredMembers(client).map((m) => {
    let parentesco;
    if (m.key === 'primary') parentesco = es ? 'Titular' : 'Primary';
    else if (m.key === 'spouse') parentesco = es ? 'Cónyuge' : 'Spouse';
    // `member` es el dependiente mismo, que ya viene en la lista: buscarlo otra
    // vez por su clave seria volver a calcular `dep`+posicion aqui, que es
    // exactamente lo que este fichero existe para no hacer.
    else parentesco = (m.member || {}).relation || (es ? 'Dependiente' : 'Dependent');
    return { key: m.key, nombre: m.name, parentesco, member: m.member };
  }).filter((p) => p.nombre);
}

/**
 * Como se llama la persona de una clave guardada.
 *
 * Si la clave ya no esta en la casa —un dependiente que se quito de la ficha, o
 * que se paso a ficha propia— NO se devuelve vacio: se devuelve un aviso. Lo
 * que estaba escrito a nombre de esa persona tiene que seguir viendose y poder
 * moverse o borrarse; esconderlo porque su dueño ya no aparece es justo la
 * forma de perder un dato sin que nadie se entere (CLAUDE.md: nunca ocultar por
 * un campo vacio).
 */
export function nombreDePersona(client, key, lang = 'es') {
  const es = lang !== 'en';
  const p = personasDelHogar(client, lang).find((x) => x.key === key);
  if (p) return p.nombre;
  return es ? 'Persona que ya no está en la ficha' : 'Person no longer on the record';
}
